<template>
  <v-row>
    <v-col
      cols="12"
    >
      <large-search-card
        :page.sync="page"
      >

      </large-search-card>
    </v-col>
    <v-col
      v-if="posts.length > 0"
      cols="12"
    >
      <v-row>
        <v-col
          v-for="post in posts"
          cols="12"
          md="6"
          lg="4"
          :key="post.id"
        >
          <post-card
            :post="post"
          >

          </post-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col
      v-if="posts.length > 0"
      cols="12"
    >
      <v-pagination
        v-model="page"
        :length="pagination.totalPages"
      >

      </v-pagination>
    </v-col>

    <v-col
      v-if="posts.length === 0 && searched"
    >
      <div
        class="text-center my-8 grey--text text-lighten-1 headline"
      >
        {{ $t('Sorry, there were no results for your search.') }}
      </div>
    </v-col>

    <v-col
      v-if="posts.length === 0 && !searched"
      cols="12"
    >
      <page-tiles
      >

      </page-tiles>
      <v-container fluid>
        <div class="grey--text text-left"
             v-if="$gd.getText('privacy-url')"
        >
          <a :href="$gd.getText('privacy-url')">
            {{ $t('Click here') }}
          </a>
          {{ $t('for our terms and conditions and privacy policy.')}}
        </div>
        <div class="grey--text text-right">
          {{ $t('This recruitment website is powered by')}} <a href="https://gorilladash.com" target="_blank" class="primary--text"><strong>Gorilla Dash</strong></a>
        </div>
      </v-container>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import setting from '@/mixins/setting';
  import LargeSearchCard from '@/components/search/LargeSearchCard.vue';
  import PostCard from '@/components/cards/PostCard';
  import PageTiles from '@/components/pages/PageTiles';
  import { all } from '@/api/content';

  export default {
    name: 'Index',
    mixins: [setting],
    data() {
      return {
        content: null,
      };
    },
    computed: {
      page: {
        set(value) {
          this.pageChange(value);
        },
        get() {
          return this.currentPage;
        },
      },
      currentUrl() {
        return window.location.href;
      },
      ...mapGetters({
        posts: 'posts/posts',
        currentPage: 'posts/page',
        pagination: 'posts/pagination',
        searched: 'posts/searched',
      }),
    },
    methods: {
      ...mapActions({
        pageChange: 'posts/pageChange',
      }),
    },
    async mounted() {
      this.content = await all();
    },
    components: {
      LargeSearchCard,
      PostCard,
      PageTiles,
    },
  };
</script>

